var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#00CC99"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2006_172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.64334 12.6261C5.45989 12.4628 5.34703 12.2347 5.32855 11.9898C5.33009 11.4689 5.75201 11.047 6.27293 11.0454L17.6457 11.0454C18.1686 11.0628 18.5784 11.5007 18.561 12.0235C18.5453 12.4963 18.1832 12.885 17.7127 12.9342L6.27291 12.9342C6.03137 12.9158 5.80609 12.8055 5.64334 12.6261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3231 18.3058C11.1482 18.1293 11.0495 17.8912 11.0485 17.6427L11.0485 6.26985C11.0889 5.74831 11.5444 5.3582 12.066 5.39854C12.5315 5.43455 12.9013 5.80437 12.9373 6.26985L12.9708 17.6762C12.988 18.199 12.5781 18.6368 12.0553 18.654C12.0345 18.6547 12.0137 18.6547 11.9929 18.654C11.731 18.6358 11.4885 18.5097 11.3231 18.3058Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2006_172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(12 4.92896) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddCampaign);
export default __webpack_public_path__ + "static/media/ICON_ADD_CAMPAIGN.c125a5737b084ed5e98cf5863ce90e20.svg";
export { ForwardRef as ReactComponent };